export const getEnumKeys = <T extends object>(enumObject: T): Array<keyof T> => {
  return Object.keys(enumObject).filter(
    (key) =>
      typeof enumObject[key as keyof T] === "string" ||
      typeof enumObject[key as keyof T] === "number"
  ) as Array<keyof T>;
};

export const getEnumValues = <T extends object>(enumObject: T): Array<T[keyof T]> => {
  return Object.values(enumObject).filter(
    (value) => typeof value === "string" || typeof value === "number"
  ) as Array<T[keyof T]>;
};

export enum COURSE_TYPE {
  EBOOK = 0,
  LINKEDIN = 1,
}

getEnumValues(COURSE_TYPE);

export const getEnumEntries = <T extends object>(enumObject: T): Array<[keyof T, T[keyof T]]> => {
  return Object.entries(enumObject).filter(
    ([, value]) => typeof value === "string" || typeof value === "number"
  ) as Array<[keyof T, T[keyof T]]>;
};
